import * as THREE from 'three'
import { createMeshFromLine,createDashedMeshLine } from '@/utils/threejsHelper'
const material_map = new Map()

// 本地地图分支里 line 也是用 Mesh 画出来的，所以不能按材质类型统一降透明。
// 这里只按元素名称识别“区域面”，避免误伤 lane / boundary 这类线状 Mesh。
const SURFACE_ELEMENT_NAMES = new Set([
  'clear_zone',
  'cross_walk',
  'free_area',
  'parking',
  'pillar',
  'prohibited_area',
  'speed_bump',
  'safety_island',
  'multiLayerArea'
])

// 第二轮视觉优化：本地地图也统一降低面元素存在感。
// 注意这里 line 也是 Mesh，所以只能按元素名称挑出“区域面”来柔化。
const DEFAULT_SURFACE_OPACITY = 0.12
const SURFACE_OPACITY_BY_NAME = {
  cross_walk: 0.14,
  clear_zone: 0.12,
  free_area: 0.1,
  parking: 0.1,
  pillar: 0.14,
  prohibited_area: 0.14,
  speed_bump: 0.48,
  safety_island: 0.12,
  multiLayerArea: 0.1
}
const SURFACE_COLOR_SOFTEN_RATIO = 0.28

const MateialSetting = {
  stop_line_1: {
    type: 'LineBasic',
    setting: {
      color: 0xffff00
    }
  },
  stop_line_2: {
    type: 'LineDashed',
    setting: {
      color: 0xffff00,
      dashSize: 1,
      gapSize: 0.5
    }
  },
  stop_line_3: {
    type: 'LineDashed',
    setting: {
      color: 0xffff00,
      dashSize: 2,
      gapSize: 0.5
    }
  },
  stop_line_4: {
    type: 'LineDashed',
    setting: {
      color: 0xffff00,
      dashSize: 2,
      gapSize: 0.5
    }
  },
  stop_line_UNKNOWN: {
    type: 'LineDashed',
    setting: {
      color: 0xffff00
    }
  },
  entry_line_UNKNOWN: {
    type: 'LineDashed',
    setting: {
      color: 0xff8800
    }
  },
  boundary_UNKNOWN: {
    type: 'LineBasic',
    setting: {
      color: 0xf0dc70
    }
  },
  boundary_3: {
    type: 'LineBasic',
    setting: {
      color: 0xd71345
    }
  },
  boundary_4: {
    type: 'LineBasic',
    setting: {
      color: 0xd71345
    }
  },
  boundary_10: {
    type: 'LineBasic',
    setting: {
      color: 0xd71345
    }
  },
  lane_UNKNOWN: {
    type: 'LineBasic',
    setting: {
      color: 0x007d65
    }
  },
  lane_1: {
    type: 'LineBasic',
    setting: {
      color: 0x007d65
    }
  },
  lane_2: {
    type: 'LineBasic',
    setting: {
      color: 0x494e8f
    }
  },
  lane_3: {
    type: 'LineBasic',
    setting: {
      color: 0x1d953f
    }
  },
  lane_4: {
    type: 'LineBasic',
    setting: {
      color: 0x1d953f
    }
  },
  lane_5: {
    type: 'LineBasic',
    setting: {
      color: 0x494e8f
    }
  },
  lane_6: {
    type: 'LineBasic',
    setting: {
      color: 0x1d953f
    }
  },
  lane_7: {
    type: 'LineBasic',
    setting: {
      color: 0x1d953f
    }
  },
  cross_walk_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0xb2d235,
      side: THREE.DoubleSide
    }
  },
  clear_zone_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0xd71345,
      side: THREE.DoubleSide
    }
  },
  free_area_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_1: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_2: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_3: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_4: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_5: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_6: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_7: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_8: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_9: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  free_area_10: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  gate_UNKNOWN: {
    type: 'LineBasic',
    setting: {
      color: 0xe0861a
    }
  },
  gate_1: {
    type: 'LineBasic',
    setting: {
      color: 0xe0861a
    }
  },
  gate_2: {
    type: 'LineBasic',
    setting: {
      color: 0xe0861a
    }
  },
  gate_3: {
    type: 'LineBasic',
    setting: {
      color: 0xe0861a
    }
  },
  gate_4: {
    type: 'LineBasic',
    setting: {
      color: 0xe0861a
    }
  },
  gate_5: {
    type: 'LineBasic',
    setting: {
      color: 0xe0861a
    }
  },
  intersection_UNKNOWN: {
    type: 'LineBasic',
    setting: {
      color: 0x501013
    }
  },
  parking_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  parking_1: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  parking_2: {
    type: 'MeshBasic',
    setting: {
      color: 0x7fb80e,
      side: THREE.DoubleSide,
      opacity: 0.3
    }
  },
  pillar_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0xf47920,
      side: THREE.DoubleSide
    }
  },
  prohibited_area_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0x800000,
      side: THREE.DoubleSide
    }
  },
  prohibited_area_1: {
    type: 'MeshBasic',
    setting: {
      color: 0x800000,
      side: THREE.DoubleSide
    }
  },
  prohibited_area_2: {
    type: 'MeshBasic',
    setting: {
      color: 0x800000,
      side: THREE.DoubleSide
    }
  },
  prohibited_area_3: {
    type: 'MeshBasic',
    setting: {
      color: 0x800000,
      side: THREE.DoubleSide
    }
  },
  speed_bump_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0xffeb3b,
      side: THREE.DoubleSide
    }
  },
  safety_island_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0xdf8864,
      side: THREE.DoubleSide
    }
  },
  multiLayerArea_UNKNOWN: {
    type: 'MeshBasic',
    setting: {
      color: 0x77787b,
      side: THREE.DoubleSide,
      transparent: true,
      opacity: 0.3
    }
  },
  free_area_solid: {
    type: 'LineBasic',
    setting: {
      color: 0x007947
    }
  },
  road_mark_3: {
    type: 'LineBasic',
    setting: {
      color: 0xffc20e
    }
  },
  road_mark_6: {
    type: 'LineBasic',
    setting: {
      color: 0xffc20e
    }
  },
  road_mark_7: {
    type: 'LineBasic',
    setting: {
      color: 0xffc20e
    }
  },
  road_mark_UNKNOWN: {
    type: 'LineBasic',
    setting: {
      color: 0xffc20e
    }
  },
}

// let mouseMaterial_lane = new THREE.MeshBasicMaterial({ color: 0xf47920 });
function getMateial(elementName, elementType) {
  elementType = elementType || 'UNKNOWN'
  const key = `${elementName}_${elementType}`
  if (material_map.has(key)) {
    return material_map.get(key)
  }
  const mSetting = MateialSetting[key]
  if (!mSetting) {
    return getMateial(elementName, 0)
  }
  let material = new THREE.MeshBasicMaterial(mSetting.setting)
  // 这里历史上统一走 MeshBasicMaterial，是因为本地地图的线条也会被拉宽成面来画。
  // 因此不能简单按材质类型区分“线”和“面”，只能按元素名称来识别区域底色。
  material.transparent = true

  if (SURFACE_ELEMENT_NAMES.has(elementName)) {
    // 区域面继续往“轻底纹”方向调：更淡、更柔和、更退后。
    // 这样线状 Mesh 仍是第一视觉层，区域只负责补充范围语义。
    material.opacity = SURFACE_OPACITY_BY_NAME[elementName] ?? DEFAULT_SURFACE_OPACITY
    material.depthWrite = false
    material.polygonOffset = true
    material.polygonOffsetFactor = 1
    material.polygonOffsetUnits = 1
    if (material.color) {
      const softenRatio = elementName === 'speed_bump' ? 0.08 : SURFACE_COLOR_SOFTEN_RATIO
      material.color.lerp(new THREE.Color(0xffffff), softenRatio)
    }
  }

  material_map.set(key, material)
  return material
}
/**
 *
 * @param {*} param0
 */
export function createLine({ name, type, element }) {
  // const heartShape = [];
  // element.pointList.forEach((e) => {
  //   // points.push(new THREE.Vector3(e.x, 0, -e.y));
  //   points.push(new THREE.Vector3(e.x, e.y, 0));
  // });

  // const geometry = new THREE.BufferGeometry().setFromPoints(points);
  
  // const line = new THREE.Line(geometry, material);
  // line.computeLineDistances();
  // line.renderOrder = 100;
  // let center = getCenterForObstacle(element.pointList);
  // line.positionEX = center;
  // line.matrixAutoUpdate = false;
  // line.mouseMaterial = mouseMaterial_lane;
  // return line;
  let heartShape = new THREE.Shape()
  // 入口线加粗，比默认 0.2 更醒目
  const lineWidth = name === 'entry_line' ? 0.5 : 0.2
  let pointsList = createMeshFromLine(element.pointList, lineWidth)
  let material = getMateial(name, type);
  pointsList.forEach((e, index) => {
    if (index == 0) {
      heartShape.moveTo(e.x, e.y)
    } else {
      heartShape.lineTo(e.x, e.y)
    }
  })
  const geometry_shape = new THREE.ShapeGeometry(heartShape)
  const mesh = new THREE.Mesh(geometry_shape, material)
  mesh.matrixAutoUpdate = false;
  mesh.renderOrder = 100;
  return mesh
}
/**
 *
 * @param {*} param0
 */
export function createLinePath({ name, type, element }) {
  const points = [];
  element.pointList.forEach((e) => {
    points.push(new THREE.Vector3(e.x, e.y, 0.02));
  });
  const geometry = new THREE.BufferGeometry().setFromPoints(points);
  let material = getMateial(name, type);
  const line = new THREE.Line(geometry, material);
  line.computeLineDistances();
  line.renderOrder = 100;
  line.matrixAutoUpdate = false;
  return line;
}
export function createLine_boundary({ name, type, element }) {
  if (type == "1" || type == "5") {
    //虚线
    return createDashedMeshLine(element.pointList, element.color);
  } else {
    let heartShape = new THREE.Shape()
    let pointsList = createMeshFromLine(element.pointList, 0.2)
    let material = getMateial(name, type);
    pointsList.forEach((e, index) => {
      if (index == 0) {
        heartShape.moveTo(e.x, e.y)
      } else {
        heartShape.lineTo(e.x, e.y)
      }
    })
    const geometry_shape = new THREE.ShapeGeometry(heartShape)
    const mesh = new THREE.Mesh(geometry_shape, material)
    mesh.matrixAutoUpdate = false;
    mesh.renderOrder = 100;
    return mesh
  }
}
export function createMesh({ name, element }) {
  let heartShape = new THREE.Shape();
  element.pointList.forEach((e, index) => {
    if (index == 0) {
      heartShape.moveTo(e.x, e.y);
    } else {
      heartShape.lineTo(e.x, e.y);
    }
  });
  const geometry_shape = new THREE.ShapeGeometry(heartShape);
  const material_shape = getMateial(name, undefined);
  // material_shape.depthTest = false;
  const mesh = new THREE.Mesh(geometry_shape, material_shape);
  mesh.renderOrder = -99;
  mesh.matrixAutoUpdate = false;

  //创建面的边界
  if (name == "free_area" || name == "parking") {
    const points = [];
    element.pointList.forEach((e) => {
      points.push(new THREE.Vector3(e.x, e.y, 0));
    });
    const geometry = new THREE.BufferGeometry().setFromPoints(points);
    let material = getMateial("free_area", "solid");
    const line = new THREE.Line(geometry, material);
    line.computeLineDistances();
    line.renderOrder = 1;
    mesh.add(line);
  }

  return mesh;
}


const getCenterForObstacle = (polygonList = []) => {
  if (polygonList.length > 0) {
    let sum = polygonList.reduce(
      (pre, cur) => {
        return { x: pre.x + cur.x, y: pre.y + cur.y }
      },
      { x: 0, y: 0 }
    )
    let center = {
      x: sum.x / polygonList.length,
      y: sum.y / polygonList.length
    }
    return center
  } else {
    return { x: 0, y: 0 }
  }
}



